import * as React from 'react';
import { Container, HoldState } from 'types/Watchlist';
import { Cell } from './Cell';
import { CellProps } from './types';
import { parsePickupInfo, TransformedHold } from './utility';

const Hold: React.FC<TransformedHold> = (props) => {
  const { name, note, state } = props;

  const indicate = state === HoldState.Hold || (state === HoldState.Unknown && !!note);
  const tagColor = indicate ? 'text-red-900' : 'text-gray-700';

  const value = state === HoldState.Unknown ? note || '-' : state;

  return (
    <div className="flex flex-col space-y-2 w-16 flex-shrink-0">
      <h5>{name}</h5>
      <h6
        className={`uppercase font-medium ${tagColor} whitespace-normal break-words overflow-auto	`}
      >
        {value}
      </h6>
    </div>
  );
};

export const HoldsCell: React.FC<CellProps> = (params) => {
  const container: Container = params.row;
  const { pickupInfo } = container;

  const { holds } = parsePickupInfo(pickupInfo);

  return (
    <Cell className="flex space-x-2">
      {holds.map((h) => (
        <Hold key={h.name} {...h} />
      ))}
    </Cell>
  );
};
HoldsCell.displayName = 'ContainerTable.HoldsCell';
